import { render, staticRenderFns } from "./SystemDataDiscovery.vue?vue&type=template&id=6b10440c&scoped=true&"
import script from "./SystemDataDiscovery.vue?vue&type=script&lang=js&"
export * from "./SystemDataDiscovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b10440c",
  null
  
)

export default component.exports